module.exports = __webpack_public_path__ + "img/share.7babdf4.svg";